import type { ReactNode } from 'react';

export function SplashscreenComponent({ children }: { children?: ReactNode }) {
  return (
    <div className="loading-progress-box">
      <div className="app-info">
        <img src="/Images/Icons/icon-192x192.png" alt="NG-SOS Portal" className="app-icon" />
      </div>

      <div className="container px-2 py-5 d-flex justify-content-center">{children}</div>
    </div>
  );
}

export function AuthenticationPageLayout({ children }: { children?: ReactNode }) {
  return <SplashscreenComponent>{children}</SplashscreenComponent>;
}
